import { HttpClient } from '../../httpClient'
import { OpalApiRequestBody, OpalApiResponseDocument } from '../../schema'

interface UpdateMomentSettingArguments {
  requestBody: OpalApiRequestBody<'UpdateMomentsSettingV2'>
}

export async function updateMomentsSetting({
  requestBody,
}: UpdateMomentSettingArguments): Promise<
  OpalApiResponseDocument<'UpdateMomentsSettingV2', 200>
> {
  const url = new URL(`/users/v2/me/moments_setting`, window.location.origin)
  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
